import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=58fd3978"
import script from "./AccountForm.vue?vue&type=script&lang=js"
export * from "./AccountForm.vue?vue&type=script&lang=js"
import style0 from "./AccountForm.vue?vue&type=style&index=0&id=58fd3978&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports